import { createContext, useContext } from 'react';

interface ConditionalFieldsContextValue {
  hiddenFields: Set<string>;
  hiddenSections: Set<string>;
}

export const ConditionalFieldsContext =
  createContext<ConditionalFieldsContextValue>({
    hiddenFields: new Set(),
    hiddenSections: new Set(),
  });

export const useConditionalFieldsContext = () => {
  const context = useContext(ConditionalFieldsContext);
  if (!context) {
    throw new Error(
      'useConditionalFieldsContext must be used within a ConditionalFieldsProvider'
    );
  }

  return context;
};

export const useIsConditionalFieldVisible = (fieldId: string) => {
  const context = useConditionalFieldsContext();

  return !context.hiddenFields.has(fieldId);
};

export const useIsConditionalSectionVisible = (sectionId: string) => {
  const context = useConditionalFieldsContext();

  return !context.hiddenSections.has(sectionId);
};
